import { Fragment, useState } from "react";
import { Container } from "react-bootstrap";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import FilterCity from "./components/FilterCity";

function CityCheck() {
  const [city, setCity] = useState({});

  const title = <h4>جست و جوی شهر</h4>;

  const cityUi = city.id ? (
    <div>
      <div className="mb-5">
        <span> استان: </span>
        <span className="fs-4 fw-semibold color-green">
          {city?.province?.faName}{" "}
        </span>
        <span className="me-3">شهر: </span>
        <span className="fs-4 fw-semibold color-green">{city?.faName}</span>
      </div>
      <h4>سرویس دهنده ها</h4>
      <hr />
      <p className="mb-1">
        <span>پست: </span>
        <span
          className={
            "fs-4 fw-semibold " +
            (city.postNumber ? "color-green" : "text-danger")
          }
        >
          {city.postNumber ? "بله" : "خیر"}
        </span>
      </p>
      <p className="mb-1">
        <span>ماهکس: </span>
        <span
          className={
            "fs-4 fw-semibold " +
            (city.mahexNumber ? "color-green" : "text-danger")
          }
        >
          {city.mahexNumber ? "بله" : "خیر"}
        </span>
      </p>
      <p className="mb-1">
        <span>چاپار: </span>
        <span
          className={
            "fs-4 fw-semibold " +
            (city.chaparNumber ? "color-green" : "text-danger")
          }
        >
          {city.chaparNumber ? "بله" : "خیر"}
        </span>
      </p>

      <p className="mb-1">
        <span>تیپاکس: </span>
        <span
          className={
            "fs-4 fw-semibold " +
            (city.tipaxCityId ? "color-green" : "text-danger")
          }
        >
          {city.tipaxCityId ? "بله" : "خیر"}
        </span>
      </p>

      <p className="mb-1">
        <span>دکاپست: </span>
        <span
          className={
            "fs-4 fw-semibold " +
            (city.dekapostCityId ? "color-green" : "text-danger")
          }
        >
          {city.dekapostCityId ? "بله" : "خیر"}
        </span>
      </p>

      <p className="mb-1">
        <span>پارسی پست: </span>
        <span
          className={
            "fs-4 fw-semibold " +
            (city.parsiPostCityId ? "color-green" : "text-danger")
          }
        >
          {city.parsiPostCityId ? "بله" : "خیر"}
        </span>
      </p>

      <p className="mb-1">
        <span>آوا اکسپرس: </span>
        <span
          className={
            "fs-4 fw-semibold " +
            (city.avaexpressCityId ? "color-green" : "text-danger")
          }
        >
          {city.avaexpressCityId ? "بله" : "خیر"}
        </span>
      </p>
    </div>
  ) : (
    <Fragment></Fragment>
  );

  const total = (
    <Container className="px-3">
      {title}
      <FilterCity setCity={data => setCity(data)} city={city} />
      {cityUi}
    </Container>
  );

  return <MainMenu data={total} />;
}

export default CityCheck;
